import { translate, useLocale } from "../../localization";
import React, { useState } from "react";
import { AppButton } from "../ui";
import BulkUploadElementDialog from "./BulkUploadElementDialog";
import useElementUploadWorkflow from "./useElementUploadWorkflow";
import DataObjectMetadataDialog from "./DataObjectMetadataEditor";

const BulkElementUploader = ({ onNewElementCreated }) => {
  useLocale();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [metadataElement, setMetadataElement] = useState(null);
  const { uploadSingleElement } = useElementUploadWorkflow();
  const handleBulkUpload = async ({ namePrefix = "", files = [], optimization, onProgress }) => {
    const results = [];
    for (const [index, file] of files.entries()) {
      try {
        const element = await uploadSingleElement({ file, name: `${namePrefix}${file.name}`, description: file.name, optimization,
          onProgress: stage => onProgress?.({ index: index + 1, count: files.length, stage }) });
        onNewElementCreated?.(element);
        results.push({ file, element });
      } catch (error) {
        results.push({ file, element: error.uploadedElement, error: error.message || translate("Upload failed") });
      }
    }
    return results;
  };
  return <>
    <AppButton kind="secondary" onClick={() => setUploadDialogOpen(true)}>{translate("Bulk Upload Elements")}</AppButton>
    <BulkUploadElementDialog open={uploadDialogOpen} onClose={() => setUploadDialogOpen(false)} onUpload={handleBulkUpload} onMetadata={setMetadataElement} />
    <DataObjectMetadataDialog element={metadataElement} onClose={() => setMetadataElement(null)} />
  </>;
};
export default BulkElementUploader;
